<template>
  <form :id="id" @submit="makeOrder">
    <section class="request" id="request-section">
      <div class="request-content" ref="content">
        <div class="request-columns">
          <div class="content">
            <div class="request-files">
              <h1>Loaded floor plans</h1>
              <div class="request-files-wrapper" ref="filesWrapper">
                <template v-for="(plan, index) in uploadPlans" :key="plan.name + index">
                  <div class="request-file">
                    <img class="request-file__icon" src="@/assets/img/plan-icon.svg" alt="plan-icon" />
                    <span class="request-file__name">{{ plan.name }}</span>
                    <button type="button" class="request-file__delete" @click="deleteFile(index)">
                      <img src="@/assets/img/delete-icon.svg" alt="delete-icon" />
                    </button>
                  </div>
                </template>
              </div>
              <label class="request-more" for="upload-plan-input">
                <img src="@/assets/img/plus-icon.svg" alt="plus-icon" />
                <input multiple accept="image/*,application/pdf" type="file" name="uploaded-plan" ref="input" id="upload-plan-input" title="" />
                <span>Upload more files</span>
              </label>
            </div>
            <div class="request-warning">
              <img class="request-warning--img" src="@/assets/img/warning-octagon-icon.svg" alt="warning octagon icon" />
              <div class="request-warning--description">
                <h5 class="request-warning--description-title">You pay for 1 apartment or 1 house floor</h5>
                <p class="request-warning--description-text">If you have a multi-level home, the payment is per level.</p>
              </div>
            </div>
            <div class="request-tariff">
              <h2 class="request-style--title">Select set of visuals</h2>

              <div class="tariff-list tariff-order-list">
                <input id="basicTariff" type="radio" name="tariff" value="1" v-model="tariff" checked />
                <label for="basicTariff">
                  <div class="tariff-item tariff-order-item">
                    <span class="tariff-item__tag tariff-order-item__tag">Basic set</span>
                    <p class="tariff-item__price tariff-order-item__price"><span>$</span>25</p>
                    <h4 class="tariff-item__count tariff-order-item__count">2D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count">3D</h4>
                  </div>
                </label>

                <input id="plusTariff" type="radio" name="tariff" value="2" v-model="tariff" />
                <label for="plusTariff">
                  <div class="tariff-item tariff-order-item">
                    <span class="tariff-item__tag tariff-order-item__tag">Plus set</span>
                    <p class="tariff-item__price tariff-order-item__price"><span>$</span>45</p>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">2D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">3D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count mobile-only">Basic set</h4>
                    <h4 class="tariff-item__count tariff-order-item__count tariff-order-item__count-plus">Virtual tour</h4>
                  </div>
                </label>

                <input id="proTariff" type="radio" name="tariff" value="3" v-model="tariff" />
                <label for="proTariff">
                  <div class="tariff-item tariff-order-item sameHeight">
                    <span class="tariff-item__tag tariff-order-item__tag">Pro set</span>
                    <p class="tariff-item__price tariff-order-item__price"><span>$</span>50</p>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">2D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">3D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">Virtual tour</h4>
                    <h4 class="tariff-item__count tariff-order-item__count mobile-only">Plus set</h4>
                    <h4 class="tariff-item__count tariff-order-item__count tariff-order-item__count-plus">Branding</h4>
                  </div>
                </label>

                <input id="renderTariff" type="radio" name="tariff" value="4" v-model="tariff" />
                <label for="renderTariff">
                  <div class="tariff-item tariff-order-item sameHeight">
                    <span class="tariff-item__tag tariff-order-item__tag">Render set</span>
                    <p class="tariff-item__price tariff-order-item__price"><span>$</span>50</p>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">2D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">3D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">Virtual tour</h4>
                    <h4 class="tariff-item__count tariff-order-item__count mobile-only">Plus set</h4>
                    <h4 class="tariff-item__count tariff-order-item__count tariff-order-item__count-plus">Renderings</h4>
                    <h4 class="tariff-item__count tariff-order-item__count tariff-order-item__count-plus desktop-only">High Quality</h4>
                  </div>
                </label>

                <input id="maxTariff" type="radio" name="tariff" value="6" v-model="tariff" />
                <label for="maxTariff">
                  <div class="tariff-item tariff-order-item">
                    <span class="tariff-item__tag tariff-order-item__tag">Max set</span>
                    <p class="tariff-item__price tariff-order-item__price"><span>$</span>70</p>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">2D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">3D</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">Virtual tour</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">Renderings</h4>
                    <h4 class="tariff-item__count tariff-order-item__count desktop-only">High Quality</h4>
                    <h4 class="tariff-item__count tariff-order-item__count mobile-only">Pro set</h4>
                    <h4 class="tariff-item__count tariff-order-item__count tariff-order-item__count-plus desktop-only">Branding</h4>
                    <h4 class="tariff-item__count tariff-order-item__count tariff-order-item__count-plus mobile-only">Renderings</h4>
                  </div>
                </label>
              </div>
            </div>
            <div class="request-style">
              <h2 class="request-style--title">Select interior style</h2>
              <div class="request-style--container">
                <div class="request-style--container-item">
                  <input id="scandyStyle" type="radio" name="roomStyle" value="scandy" v-model="roomStyle" checked />
                  <label for="scandyStyle">
                    <img class="request-style--container-item-img" src="@/assets/img/scandy-style-preview.jpg" alt="style icon" />
                    <div class="request-style--container-item-name">Scandy</div>
                  </label>
                </div>
                <div class="request-style--container-item">
                  <input id="bohoStyle" type="radio" name="roomStyle" value="boho" v-model="roomStyle" />
                  <label for="bohoStyle">
                    <img class="request-style--container-item-img" src="@/assets/img/boho-style-preview.jpg" alt="style icon" />
                    <div class="request-style--container-item-name">Boho</div>
                  </label>
                </div>
                <div class="request-style--container-item">
                  <input id="englandStyle" type="radio" name="roomStyle" value="england" v-model="roomStyle" />
                  <label for="englandStyle">
                    <img class="request-style--container-item-img" src="@/assets/img/england-style-preview.jpg" alt="style icon" />
                    <div class="request-style--container-item-name">England</div>
                  </label>
                </div>
                <div class="request-style--container-item">
                  <input id="neutralStyle" type="radio" name="roomStyle" value="zero" v-model="roomStyle" />
                  <label for="neutralStyle">
                    <img class="request-style--container-item-img" src="@/assets/img/neutral-style-preview.jpg" alt="style icon" />
                    <div class="request-style--container-item-name">Neutral</div>
                  </label>
                </div>
                <div class="request-style--container-item">
                  <input id="modernStyle" type="radio" name="roomStyle" value="modern" v-model="roomStyle" />
                  <label for="modernStyle">
                    <img class="request-style--container-item-img" src="@/assets/img/modern-style-preview.jpg" alt="style icon" />
                    <div class="request-style--container-item-name">Modern</div>
                  </label>
                </div>
                <div class="request-style--container-item">
                  <input id="japandiStyle" type="radio" name="roomStyle" value="japandi" v-model="roomStyle" />
                  <label for="japandiStyle">
                    <img class="request-style--container-item-img" src="@/assets/img/japandi-style-preview.jpg" alt="style icon" />
                    <div class="request-style--container-item-name">Japandi</div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="request-info__total">
          <div class="request-info__total-content">
            <h2>Order summary</h2>
            <h3>
              <span>{{ calculatedPrice.count }}</span> floor plans processing
            </h3>

            <div class="request-info__total-count">
              <template v-for="(count, price) in calculatedPrice.items" :key="price">
                <div>
                  <p class="request-info__total-count--text">
                    $<span>{{ price.replace('.', ',') }}</span> x <span>{{ count }}</span> floor plan
                  </p>
                </div>
              </template>
            </div>
            <hr />
            <div class="request-info__total-result">
              <h3>Order total</h3>
              <span class="request-info__total-result-price">{{ `$${calculatedPrice.sum}`.replace('.', ',') }}</span>
            </div>
          </div>
        </div>
        <div class="request-info__promo">
          <div class="request-info__promo-content">
            <h2>Use discount code</h2>
            <input ref="inputPromo" type="text" name="promocode" placeholder="Enter discount code" v-model="promo" />
            <p ref="errorMessagePromo" style="display: none; color: red">{{ errorMessagePromo }}</p>
            <button
              ref="resetPromo"
              type="button"
              class="reset"
              @click="
                () => {
                  promo = '';
                }
              ">
              <img src="@/assets/img/X_close.svg" alt="close" />
            </button>
          </div>
        </div>
        <div class="custom-form">
          <div class="content">
            <p class="custom-form__title">You will receive the result in 1 business day by email</p>

            <div class="custom-form__input">
              <div class="input-block">
                <input type="email" name="email" placeholder="E-mail" data-orders-form="email" v-model="email" />
                <p class="styled-input__error-text error-text">{{ errorMessageEmail }}</p>
              </div>
              <div class="radio-input-block">
                <p class="radio-input-block__description">Introduce yourself:</p>
                <div class="radio-input-block__buttons">
                  <div class="radio-input-block__buttons-item">
                    <input id="company" type="radio" name="radio" value="company" v-model="customerType" checked />
                    <label for="company">Company</label>
                  </div>
                  <div class="radio-input-block__buttons-item">
                    <input id="personal" type="radio" name="radio" value="personal" v-model="customerType" />
                    <label for="personal">Personal</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="request-send">
          <button id="submit" class="request-send-button" type="submit" :disabled="buttonDisabled">Make payment</button>
        </div>
      </div>
    </section>
  </form>
</template>

<script>
import { api } from '@/api';
import { smoothScroll } from '@/helpers';
import { triggeringYandexMetric } from '@/assets/js/yandex-metrics';
import { triggeringGoogleTagMetric } from '@/assets/js/google-tag-metrics';

export default {
  props: {
    id: {
      default: null,
      type: String,
    },
    close: {
      default: () => null,
      type: Function,
    },
    plans: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      uploadPlans: {},
      email: '',
      customerType: 'company',
      roomStyle: 'scandy',
      tariff: 2,
      promo: '',
      promoPrice: 28,
      errorMessagePromo: '',
      errorMessageEmail: '',
      buttonDisabled: true,
      calculatedPrice: {
        count: 0,
        items: {},
        sum: 0,
      },
    };
  },
  watch: {
    uploadPlans: {
      handler() {
        if (this.uploadPlans.length === 0) {
          this.close();
        } else {
          this.calculatePrice();
        }
      },
      deep: true,
    },
    promo() {
      this.errorMessagePromo = '';
      this.setVisibilityResetPromo(this.promo);
      this.calculatePrice();
    },
    errorMessagePromo(text) {
      if (text === '') {
        this.$refs.errorMessagePromo.style.display = 'none';
      } else {
        this.$refs.errorMessagePromo.style.display = 'block';
      }
    },
    tariff() {
      this.calculatePrice();
    },
  },

  mounted() {
    smoothScroll(this.id);
    this.uploadPlans = this.plans;
    this.calculatePrice();
    this.promoPrice = 28;
    this.$refs.input.onclick = () => {
      this.value = null;
    };

    this.$refs.input.onchange = (event) => {
      this.uploadFiles(event.target.files);
    };
    if (process.env.NODE_ENV === 'production') {
      try {
        triggeringYandexMetric.openFormImage();
        triggeringGoogleTagMetric.openFormImage();
      } catch (error) {
        console.error(error);
      }
    }
  },

  methods: {
    setVisibilityResetPromo(promo) {
      if (promo === '') {
        this.$refs.resetPromo.style.display = 'none';
      } else {
        this.$refs.resetPromo.style.display = 'block';
      }
    },

    uploadFiles(files) {
      Array.from(files).forEach((file) => {
        this.uploadPlans.push(file);
      });
      this.setVisibilityResetPromo(this.promo);
      this.calculatePrice();
    },

    deleteFile(index) {
      this.uploadPlans.splice(index, 1);
    },

    calculatePrice() {
      const params = {
        count: this.plans.length,
        tariff_id: Number(this.tariff),
      };
      if (this.promo) {
        params.promocode = this.promo;
      }
      api.getCalculatedPriceEn(params).then(({ data }) => {
        this.calculatedPrice = {
          ...data,
          count: this.uploadPlans.length,
        };
      });
      this.buttonDisabled = false;
    },

    resetForm() {
      this.email = '';
      this.promo = '';
      this.uploadPlans = [];
      this.errorMessageEmail = '';
      this.errorMessagePromo = '';
      this.customerType = 'company';
      this.roomStyle = 'scandy';
      this.tariff = 2;

      this.calculatedPrice = {
        items: [],
        count: 0,
        sum: 0,
      };
    },

    makeOrder(e) {
      e.stopPropagation();
      e.preventDefault();

      this.buttonDisabled = true;
      const fd = new FormData();

      fd.append('email', this.email);
      fd.append('customer_type', this.customerType);
      fd.append('style', this.roomStyle);
      fd.append('tariff_id', Number(this.tariff));

      this.uploadPlans.forEach((plan) => fd.append('plans[]', plan));

      if (this.promo) {
        fd.append('promocode', this.promo);
      }

      if (!this.email) {
        this.errorMessageEmail = 'Please, enter your email';
        this.buttonDisabled = false;
        return;
      }

      api
        .createOrder(fd)
        .then(({ data }) => {
          if (process.env.NODE_ENV === 'production') {
            try {
              triggeringYandexMetric.submitFormImage();
              triggeringGoogleTagMetric.submitFormImage();
            } catch (err) {
              console.error(err);
            }
          }
          this.resetForm();
          this.$store.commit('setPaymentLink', data.data.payment_link);
          this.$router.push({ path: '/checkout' }).then(() => window.scrollTo(0, 0));
        })
        .catch((err) => {
          console.log(err);

          this.errorMessageEmail = '';
          this.errorMessagePromo = '';

          const { message } = err.response.data;

          if (message.includes('Invalid code') || message.includes('Already used')) {
            this.errorMessagePromo = message;
          } else {
            this.errorMessageEmail = message;
          }
        })
        .finally(() => {
          this.buttonDisabled = false;
        });
    },
  },
};
</script>
